import Vue from "vue";
import Vuetify from "vuetify";

export default function useVuetify() {
	Vue.use(Vuetify);
}
